/**------------------------------------------------------
 * Enums
 */
export enum EnumGetApiTokensUsageType {
	Debit  = 'debit',
	Credit = 'credit'
}


/**------------------------------------------------------
 * Interfaces
 */
export interface IGetApiTokensUsageRequest {
	fromDate 		: string;
	toDate 			: string;
}

export interface IGetApiTokensUsageResponse {
	results			: IGetApiTokensUsageData[];
}

export interface IGetApiTokensUsageData {
	type 			: EnumGetApiTokensUsageType;
	date 			: string; // createdAt
	info 			: string; // reason
	balanceAfter 	: number;
	apiTokensDetail : IApiTokensDetail[];
}

export interface IApiTokensDetail {
	passthroughId 	: string;
	tokensAmount  	: number;
}
